import { Subject } from 'rxjs';
import { Wizard } from '../wizard';
import { WizardTimeTravelData } from './wizard-step';
import { WizardStepTracker } from './wizard-step-tracker';

export class WizardController {
  private _wizardInstance!: Wizard;

  private _complete = new Subject<void>();

  private _requestBack = new Subject<void>();

  isCompleted: boolean = false;

  complete = this._complete.asObservable();

  requestBack = this._requestBack.asObservable();

  get currentStep$() {
    return this._wizardInstance.currentStep$;
  }

  get wizardState$() {
    return this._wizardInstance.wizardState$;
  }

  markAsComplete() {
    this.isCompleted = true;
    this._complete.next();
    this._complete.complete();
  }

  saveWizardStepData() {
    return this._wizardInstance.saveStepBeforeUnload();
  }

  setWizardInstance(instance: Wizard) {
    this._wizardInstance = instance;
  }

  constructor(private _stepTracker: WizardStepTracker) {}

  getStepTracker(): WizardStepTracker {
    return this._stepTracker;
  }

  selectStep(path: string) {
    this._wizardInstance.goTo(path);
  }

  fastTravel(data: WizardTimeTravelData<object>) {
    this._wizardInstance.fastTravel(data);
  }

  goBack() {
    this._requestBack.next();
  }

  closeWizard() {
    this._wizardInstance.closeWizard();
  }
}
